export default "__VITE_ASSET__CaQptW0e__"